import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { RetireReadyPromoCard } from './RetireReadyPromoCard'

export const RetireReadyPromoCardRegistration = createRegisterableComponent(
    'retire-ready-promo-card',
    () => <RetireReadyPromoCard />,
)
